import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from '@theme-ui/components';
import { DisplayIcon, Icon } from '../atoms';
import { colors, typography } from '../../styles/theme';

const SelectionCard = ({
	title,
	titleColor,
	variant,
	showRightIcon,
	iconRightName,
	iconName,
	iconColor,
	iconTheme,
	customIconStyles,
	onClick,
	children,
	customStyles,
}) => {
	return (
		<Flex
			sx={{
				alignItems: variant === 'full' ? 'flex-start' : 'center',
				userSelect: 'none',
				...styles.container,
				...customStyles,
			}}
			onClick={onClick}
		>
			<Flex sx={{ alignItems: 'center', gap: 3}}>
				{iconName && (
					<DisplayIcon
						iconName={iconName}
						theme={iconTheme}
						iconColor={iconColor}
						iconStyles={customIconStyles}
					/>
				)}
				<Box>
					<Box sx={{ ...typography.textMd500, color: titleColor }}>{title}</Box>
					{children}
				</Box>
			</Flex>
			{showRightIcon && (
				<Box sx={styles.rightIcon}>
					<Icon
						name={iconRightName}
						color={colors.primaryMain}
						pointerCursor
						size={24}
					/>
				</Box>
			)}
		</Flex>
	);
};

const styles = {
	container: {
		p: '1rem',
		gap: '1rem',
		border: '1px solid',
		borderColor: colors.neutral200,
		borderRadius: '0.5rem',
    justifyContent: 'space-between',
		height: '100%',
	},
	leftImage: {
		width: '4rem',
		height: '4rem',
		borderRadius: '0.5rem',
		mr: '1rem'
	},
	rightIcon: {
		minWidth: '1.5rem',
		width: '1.5rem',
		height: '1.5rem',
	},
};

SelectionCard.propTypes = {
	title: PropTypes.string,
	titleColor: PropTypes.string,
	variant: PropTypes.oneOf[('full', 'noBody')],
	showRightIcon: PropTypes.bool,
	iconRightName: PropTypes.string,
	iconName: PropTypes.string,
	iconColor: PropTypes.string,
	iconTheme: PropTypes.string,
	customIconStyles: PropTypes.object,
	onClick: PropTypes.func,
	children: PropTypes.element,
  customStyles: PropTypes.object
};

SelectionCard.defaultProps = {
	variant: 'noBody',
	iconRightName: 'TrendingUp',
	showRightIcon: false
};

export default SelectionCard;
